import axiosIns from "@/api/axios";

export const UPLOAD_CERTIFICATE_IDP_LEARNING = (id, data) => {
  let url = `/idp/structured-learnings/upload-certificate/${id}`;

  return axiosIns.post(url, data, { headers: { "Content-Type": "multipart/form-data" } });
};

export const UPLOAD_PRESENTATION_IDP_SOCIAL_LEARNING = (id, data) => {
  let url = `/idp/social-learnings/upload-presentation/${id}`;

  return axiosIns.post(url, data, { headers: { "Content-Type": "multipart/form-data" } });
};

export const GET_DETAIL_SOCIAL_LEARNING = (payload) => {
  const { id, query } = payload;

  let url = `/idp/social-learnings/detail/${id}`;

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_DETAIL_EXPERIENTIAL_LEARNING = (payload) => {
  const { id, query } = payload;

  let url = `/idp/experiential-learnings/detail/${id}`;

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const UPDATE_COACHING_SUMMARY = (id, data) => {
  let url = `/idp/social-learnings/summary/${id}`;

  return axiosIns.put(url, data, { headers: { "Content-Type": "multipart/form-data" } });
};

export const SUBMIT_FEEDBACK_SUMMARY = (id, data) => {
  let url = `/idp/social-learnings/feedback/${id}`;

  return axiosIns.put(url, data);
};

export const KICK_OFF_PROJECT_EXPERIENTIAL_LEARNING = (id, data) => {
  let url = `/idp/experiential-learnings/project-activities/${id}/kick-off`;

  return axiosIns.put(url, data);
};

export const SUBMIT_FEEDBACK_PROJECT_EXPERIENTIAL_LEARNING = (id, data) => {
  let url = `/idp/experiential-learnings/project-activities/${id}/feedback`;

  return axiosIns.post(url, data);
};

export const UPLOAD_EVIDENCE_EXPERIENTIAL_LEARNING = (id, data) => {
  let url = `/idp/experiential-learnings/project-activities/${id}/evidence`;

  return axiosIns.put(url, data, { headers: { "Content-Type": "multipart/form-data" } });
};

export const ADD_PROGRESS_PROJECT_EXPERIENTIAL_LEARNING = (id, data) => {
  let url = `/idp/experiential-learnings/project-activities/${id}/progress`;

  return axiosIns.post(url, data, { headers: { "Content-Type": "multipart/form-data" } });
};

export const ADD_SCHEDULES_IDP_SOCIAL_LEARNING = (id, data) => {
  let url = `/idp/social-learnings/add-schedules/${id}`;

  return axiosIns.post(url, data);
};

export const COMPLETE_SOCIAL_LEARNING = (payload) => {
  const { id } = payload;

  let url = `/idp/social-learnings/complete/${id}`;

  return axiosIns.get(url);
};
